import { render, staticRenderFns } from "./ReceiveETH.vue?vue&type=template&id=5307a567&"
import script from "./ReceiveETH.vue?vue&type=script&lang=js&"
export * from "./ReceiveETH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports